import { gql } from '@apollo/client';

export const UPDATE_CLINIC_PARENT_CONTACT_FROM_PIMS = gql`
  mutation updateClinicPetParentContactInfoFromPims($where: ClinicPetParentWhereUniqueInput!) {
    updateClinicPetParentContactInfoFromPims(where: $where) {
      id
      firstName
      lastName
      updatedAt
      email
      phoneNumbers {
        id
        number
        isPrimary
        isMobile
        isDeleted
        updatedAt
      }
    }
  }
`;
